export enum ClientsApplicationsLoadingEnum {
    Loading,
    Pagination,
    Deleting,
    Searching,
    Filtering,
    Adding,
    Creating,
    Updating,
    Refreshing
} 